module.exports = __webpack_public_path__ + "static/media/banner3.d6ca53c6.png";